<template>
    <div class="form-input">
        <div class="form-input-header">
            <div class="label">{{ label }}</div>
            <div v-if="note" class="note">{{ note }}</div>
        </div>
        <div class="form-input-field">
            <input
                type="text"
                v-model="element[field]"
                :placeholder="placeholder"
                :maxlength="maxlength === 0 ? false : maxlength"
            />
            <div v-if="errorHas" class="form-input-error">
                {{ errorMessage }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InputText',
    props: {
        field: {
            type: String,
            required: true,
        },
        element: {
            type: Object,
            required: true,
        },
        errors: {
            type: Object,
            required: false,
        },
        label: {
            type: String,
            required: false,
        },
        note: {
            type: String,
            required: false,
        },
        placeholder: {
            type: String,
            required: false,
        },
        maxlength: {
            type: Number,
            required: false,
            default: 0,
        },
    },
    computed: {
        errorHas() {
            return this.errors && typeof this.errors[this.field] !== 'undefined' && this.errors[this.field];
        },
        errorMessage() {
            return this.errors[this.field].join('<br/>');
        },
    },
};
</script>
